import { useEffect, useState } from "react";

/**
 * Debounces a value. Returns the value AFTER it has remained stable for `delay` ms.
 * Use for filtering large lists (>100 items) on user-typed queries.
 *
 *   const q = useDebounced(searchQuery, 150);
 *   const filtered = useMemo(() => list.filter(x => x.startsWith(q)), [list, q]);
 */
export function useDebounced(value, delay = 150) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
